import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `audit/historical/info?dossierId=${dossierId}`, method: 'GET', body: null, token: token })
}
